import { createFileRoute, Link } from '@tanstack/react-router';
import { useJobs } from '@/lib/api/queries';
import { formatInt } from '@/lib/format';
import { StatusBadge } from '@/components/StatusBadge';

function Runs() {
  const { data: jobs, isLoading } = useJobs();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight">Runs</h1>
          <p className="text-sm text-secondary">Suivi en direct de vos extractions.</p>
        </div>
        <Link to="/new" className="rounded-control bg-accent px-4 py-2 text-sm font-semibold text-white">
          Nouveau run
        </Link>
      </div>

      {isLoading ? <p className="text-sm text-secondary">Chargement…</p> : null}

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {jobs?.map((job) => {
          const pct = job.tasks_total > 0
            ? Math.round((job.tasks_done / job.tasks_total) * 100)
            : 0;
          return (
            <Link
              key={job.id}
              to="/runs/$runId"
              params={{ runId: job.id }}
              className="rounded-card bg-surface p-5 shadow-card transition-shadow hover:shadow-float"
            >
              <div className="flex items-start justify-between gap-3">
                <p className="min-w-0 truncate font-bold">{job.name}</p>
                <StatusBadge status={job.status} />
              </div>
              <div className="mt-4 h-2 overflow-hidden rounded-full bg-sunken">
                <div className="h-full rounded-full bg-accent transition-all" style={{ width: `${pct}%` }} />
              </div>
              <dl className="mt-4 grid grid-cols-3 gap-2 text-xs">
                <div>
                  <dt className="text-tertiary">Zones</dt>
                  <dd className="font-semibold tabular-nums">
                    {formatInt(job.tasks_done)}/{formatInt(job.tasks_total)}
                  </dd>
                </div>
                <div>
                  <dt className="text-tertiary">Leads</dt>
                  <dd className="font-semibold tabular-nums">{formatInt(job.places_new)}</dd>
                </div>
                <div>
                  <dt className="text-tertiary">Appels</dt>
                  <dd className="font-semibold tabular-nums">{formatInt(job.api_calls_used)}</dd>
                </div>
              </dl>
              {job.error_message ? (
                <p className="mt-3 rounded-control bg-tint-pink px-2 py-1 text-xs text-danger">
                  {job.error_message}
                </p>
              ) : null}
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export const Route = createFileRoute('/runs/')({ component: Runs });
